import React from 'react'
// import PropTypes from 'prop-types'
import _, { cloneDeep, isEmpty, isEqual, set } from 'lodash'
import { Col, Icon, Modal, Row, Switch, message, Tooltip as AntToolTip } from 'antd'

import './../../ui/ui.style.scss'
import placeholderImage from './../../../assets/images/default-image.jpg'
import { findFileExtension, generateCroppedThumbnail, getFileSize } from './../../../util/util'
import ButtonContainer from './../general/buttons/ButtonContainer'
import PopoverConfirm from './../feedback/PopoverConfirm'
import EditIcon from './../general/icons/EditIcon'
import InputNumberApp from './../dataEntry/inputs/InputNumberApp'
// import TextAreaAppInput from './../dataEntry/inputs/TextAreaApp'
import AddBucketConfigAppModal from '../dataEntry/other/AddBucketConfigAppModal'
import AddImageModal from '../dataEntry/other/AddImageModal'
import EditImageModal from '../dataEntry/other/EditImageModal'
import RichText from './../dataEntry/other/RichText'
import { utilityService } from '../../../services/UtilityService'
import InputApp from './../dataEntry/inputs/InputApp'
import AddIcon from './../general/icons/AddIcon'
import Tooltip from './../dataDisplay/ToolTip'
import InformationIcon from '../general/icons/InformationIcon'
import JsonArrayViewModal from './JsonArrayViewModal'
// import EditButton from '../general/buttons/EditButton'
import CopyLinkButton from '../general/buttons/CopyLinkButton'
import BucketAppViewModal from './BucketAppViewModal'
import { DATE_TIME_TYPE, FILE_TYPE, JASON_EDITOR_OPTIONS_TO_REMOVE, JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE, JSON_EDITOR_INDENTATION } from 'constants/general-constants'
import moment from 'moment'
import DateTimePicker from 'components/ui/dataEntry/inputs/DatePicker'
import JsonEditor from './JsonEditor'
import { getJsonEditorArrayValue, getJsonEditorContent } from './utils'
import CustomMetaFileTypeIcon from '../dataEntry/other/CustomMetaFileTypeIcon'
import CustomMetaFileUploadIcon from '../dataEntry/other/CustomMetaFileUploadIcon'
import CustomMetaFileModal from '../dataEntry/other/CustomMetaFileModal'

const parentCompoent = 'single-app-config-modal'
const DEFAULT_MODE_JSON_ARRAY = 'table'

class SingleAppConfigs extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showAddIcon: false,
      selectedImgConfigIcon: null,
      showBucketAddIcon: false,
      selectedBucketconfigIcon: null,
      showBucketDetails: false,
      isJsonEditorImageModalOpen: false,
      jsonEditorImagePathDetails: null,
      jsonEditorModes: {},
      isCustomMetaRichTextModalOpen: {}
    }

    this.isInitialJsonEditorChange = true
    this.isInitialJsonEditorValue = null
    this.isFormDirty = this.props.isConfigSingleInstanceEdited
  }

  hideImgAddIcon = () => {
    this.setState({
      showAddIcon: false,
      selectedImgConfigIcon: null
    })
  }

  showImgAddIcon = (selectedImgConfigIcon) => {
    this.setState({
      showAddIcon: true,
      selectedImgConfigIcon: selectedImgConfigIcon
    })
  }

  hideBucketAddIcon = () => {
    this.setState({
      showBucketAddIcon: false,
      selectedBucketconfigIcon: null
    })
  }

  showBucketAddIcon = (selectedBucketConfigIcon) => {
    this.setState({
      showBucketAddIcon: true,
      selectedBucketconfigIcon: selectedBucketConfigIcon
    })
  }

  showImageDetails = (config, imageDetails, index) => {
    const { project, handleSingleConfigDetailsChange, showImgEditorIcon, hideImgEditorIcon, showEditIcon, showImgEditor, selectedImgEditConfig, isUpdateDisabled } = this.props
    let imageUrl
    if (imageDetails) {
      imageUrl = generateCroppedThumbnail(imageDetails, 214, 120, '16:9')
    }
    const category = imageDetails && imageDetails.category ? imageDetails.category.label : null
    const imageSize = getFileSize(imageDetails.fileSize)
    return <div className={project !== 'hyperion' || 'projectx' ? 'image-content' : 'image-content-hyperion'} key={index}>
      <div className='img-container' onMouseEnter={() => showImgEditorIcon(config, imageDetails)}
        onMouseLeave={hideImgEditorIcon}>
        {<img src={imageUrl} />}
        { (showEditIcon && !isUpdateDisabled && selectedImgEditConfig.name === config.name) ? <div onClick={showImgEditor} className='img-editor-icon'> <EditIcon /> </div> : null }
      </div>
      <div className='image-content-wrapper' key={index}>
        <div className='image-content-header'>
          {imageDetails.name.length > 15 ? <ButtonContainer displayTitle={imageDetails.name} childComponent={<p>{ imageDetails.name }</p>} /> : <p>{ imageDetails.name }</p> }
          {isUpdateDisabled ? null : <div className='image-content-btns'>
            <PopoverConfirm confirm={() => handleSingleConfigDetailsChange(config, null)} parentCompoent={parentCompoent} />
          </div>}
        </div>
        <div className='image-content-details'>
          <div className='image-info'>
            <p>Output Format:</p>
            <p> { findFileExtension(imageDetails.name) || 'JPG'}</p>
          </div>
          {category ? <div className={`image-info ${category ? '' : 'hidden'}`}>
            <p>Category:</p>
            <p>{category}</p>
          </div> : ''}
          <div className={`image-info ${imageSize ? '' : 'hidden'}`}>
            <p>Original File Size:</p>
            <p>{imageSize}</p>
          </div>
        </div>
      </div>
    </div >
  }

  showBucketDetails = (meta, bucketDetails, index) => {
    const { handleSingleConfigDetailsChange, project, isUpdateDisabled } = this.props
    const { showBucketDetails } = this.state
    let isBucketPublished = bucketDetails && bucketDetails.isPublished
    let bucketId = bucketDetails && bucketDetails.id
    let copyLink = () => {
      var anchor = document.createElement('a')
      anchor.href = `${location.origin}/buckets/preview/${bucketId}`
      anchor.target = '_blank'
      document.body.appendChild(anchor)
      anchor.click()
    }
    const status = utilityService.getPublishStatus(bucketDetails.isPublished, bucketDetails.publishStartDate, bucketDetails.publishEndDate)
    return <div className={'bucket-content-hyperion'} key={index}>
      <div className='bucket-content-wrapper' key={index}>
        <div className='bucket-content-header'>
          { <a onClick={this.handlBucketDetails}>{ bucketDetails.name }</a> }
          <div className='bucket-content-btns'>
            <div className='preview-button'>
              <ButtonContainer displayTitle='View API Response' childComponent={<CopyLinkButton onClick={copyLink} isDisabled={!isBucketPublished} />} />
            </div>
            {isUpdateDisabled ? null : <PopoverConfirm confirm={() => handleSingleConfigDetailsChange(meta, null)} parentCompoent={parentCompoent} />}          </div>
        </div>
        <div className='bucket-content-details'>
          <div className='bucket-right-info'>
            <p>{ status }</p>
            <p>{bucketDetails.key}</p>
          </div>
          <div className='bucket-left-info'>
            <p>{bucketDetails.displayName }</p>
            <p>{bucketDetails.displayType && bucketDetails.displayType.name}</p>
          </div>
        </div>
      </div>
      <BucketAppViewModal
        isVisible={showBucketDetails}
        handleCancel={this.hideBucketDetails}
        bucketDetails={bucketDetails}
        project={project}

      />
    </div >
  }

  handleJsonArrayChange = (config, value) => {
    this.props.handleSingleConfigDetailsChange(config, value)
  }

  handleOpenImageModal = (flag, context, config, selectedMeta) => {
    // console.log('selectedMeta', { flag, context, config, selectedMeta })
    if (flag) {
      this.setState({
        isJsonEditorImageModalOpen: true,
        jsonEditorImagePathDetails: {
          selection: context.selection,
          config,
          selectedMeta
        }
      })
    } else {
      this.setState({
        isJsonEditorImageModalOpen: false,
        jsonEditorImagePathDetails: null
      })
    }
  }

  handleContextMenuOptions = ({ items, context, config, selectedMeta, readOnly }) => {
    let contextMenuItemsNeeded = cloneDeep(items)
    const isValueContextType = context?.selection?.type === 'value'
    // if context menu opened on value type show image option
    // if (isValueContextType) {
    const isTableView = contextMenuItemsNeeded.length === 2
    const isTreeView = !isTableView
    let details = contextMenuItemsNeeded
    const imageOption = {
      type: 'button',
      onClick: () => this.handleOpenImageModal(true, context, config, selectedMeta),
      // icon: <Plus/>,
      text: '+ Image',
      title: 'Add image',
      disabled: readOnly || !isValueContextType
    }
    if (isTreeView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        const itemWithCUtCopyEdit = 2
        if (index === itemWithCUtCopyEdit) {
          return {
            type: 'row',
            items: [imageOption]
          }
        } else {
          if (item.type === 'row') {
            return {
              ...item,
              items: item.items.map(rowItem => {
                if (rowItem.type === 'column') {
                  return {
                    ...rowItem,
                    items: rowItem.items.filter(columnItem => {
                      if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                        return false
                      }
                      return true
                    })
                  }
                } else {
                  return rowItem
                }
              })
            }
          } else {
            return item
          }
        }
      })
    }
    if (isTableView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        if (item.type === 'row') {
          return {
            ...item,
            items: item.items.map(rowItem => {
              if (rowItem.type === 'column') {
                let hasTableRow = false
                const filteredColumns = rowItem.items.filter(columnItem => {
                  if (columnItem.text === 'Table row:') {
                    hasTableRow = true
                  }
                  if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem?.main?.text) || JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                    return false
                  }
                  return true
                })
                if (hasTableRow) {
                  filteredColumns.push(imageOption)
                }
                return {
                  ...rowItem,
                  items: filteredColumns
                }
              } else {
                return rowItem
              }
            })
          }
        } else {
          return item
        }
      })
    }
    return details
    // }
    // return contextMenuItemsNeeded
  }

  handleJsonEditorOpenClose = (flag, id) => {
    if (flag) {
      // open modal
      this.setState(prevState => {
        return {
          ...prevState,
          jsonEditorsOpen: {
            ...prevState.jsonEditorsOpen,
            [id]: true
          }
        }
      })
    } else {
      // clone modal
      this.setState(prevState => {
        return {
          ...prevState,
          jsonEditorsOpen: {
            ...prevState.jsonEditorsOpen,
            [id]: false
          }
        }
      })
    }
  }

  handleJsonEditorModes = (mode, id) => {
    this.setState(prevState => {
      return {
        ...prevState,
        jsonEditorModes: {
          ...prevState.jsonEditorModes,
          [id]: mode
        }
      }
    })
  }

  setDefaultMode = (jsonEditorValue, config, DEFAULT_MODE) => {
    if (isEmpty(jsonEditorValue?.text || jsonEditorValue?.json)) {
      console.log('set text')
      this.handleJsonEditorModes('text', config.id)
    } else {
      console.log('default set')
      this.handleJsonEditorModes(DEFAULT_MODE, config.id)
    }
  }

  getObjectMetaFields = (configData, selectedAppConfig) => {
    const { handleSingleConfigDetailsChange, project, handleShowAddImageModal, hideAddImageModal, saveCurrentImageSelection, showAddImageModal,
      handleShowBucketModal, showAddBucketModal, hideAddBucketModal, handleBucketSelection, selectedBucket, saveCurrentBucketSelection,
      showImgEditModal, hideImgEditor, selectedBucketConfig, selectedImgConfig, editImageDetails,
      handleJsonArrayVisibilty,
      isUpdateDisabled
      // isJsonArrayValid
      // jsonInvalidEntries,
    } = this.props
    const { showAddIcon, selectedImgConfigIcon, selectedBucketconfigIcon, showBucketAddIcon, isCustomMetaRichTextModalOpen } = this.state
    const configFields = selectedAppConfig ? _.cloneDeep(selectedAppConfig) : []
    const image = placeholderImage
    return (configFields || []).map((config, index) => {
      const selectedMeta = (configData || []).find(item => item.name === config.name && item.type === config.type)
      if (config.type === 'BOOLEAN') {
        return <div className='switch-container' key={index}>
          <div className={`switch-inner-container`} >
            <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}{config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
            <Switch checked={selectedMeta ? (selectedMeta.value === 'false' ? false : selectedMeta.value) : false} disabled={isUpdateDisabled} onChange={(value) => handleSingleConfigDetailsChange(config, value)} />
          </div>
        </div>
      } else if (config.type === 'STRING') {
        return <InputApp
          key={index}
          title={config.name}
          readOnly={isUpdateDisabled}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? selectedMeta.value : ''}
          handleChange={({ target }) => handleSingleConfigDetailsChange(config, target.value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          tooltipText={config && config.tooltipText}
        />
      } else if (config.type === 'NUMBER') {
        return <InputNumberApp
          limit={16}
          readOnly={isUpdateDisabled}
          key={index}
          title={config.name}
          placeholder={`Enter ${config.name}`}
          inputName='title'
          isRequired={config.isRequired}
          value={selectedMeta ? parseInt(selectedMeta.value) : null}
          handleChange={(value) => handleSingleConfigDetailsChange(config, value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          tooltipText={config && config.tooltipText}
        />
      } else if (config.type === 'RICHTEXT') {
        return <div className={`rich-text-container`} key={index}>
          <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}
            {config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
          <RichText key={config.id} id={config.id} text={selectedMeta ? selectedMeta.value : ''} readOnly={isUpdateDisabled} onRichTextChange={value => handleSingleConfigDetailsChange(config, value)} showCloseIcon={false} />
        </div>
      } else if (config.type === 'JSON') {
        // const needJsonParse = typeof selectedMeta?.value === 'string' && selectedMeta?.value
        // console.log('needJsonParse', needJsonParse)
        // console.log('selectedMeta?.value', JSON.parse(selectedMeta?.value))
        // console.log('before ', selectedMeta?.value)
        // console.log('isJsonString ', isJsonString(selectedMeta?.value))
        // const value = isJsonString(selectedMeta?.value)
        //   ? (needJsonParse) ? JSON.parse(selectedMeta?.value) : selectedMeta?.value
        //   : {}
        const DEFAULT_MODE = 'tree'
        const mode = this.state.jsonEditorModes?.[config.id] || DEFAULT_MODE
        const jsonEditorValue = selectedMeta?.jsonEditorValue || getJsonEditorContent(selectedMeta?.value)
        const getJsonEditorComponent = (readOnly, mode) => {
          return (
            <JsonEditor
              name={config.name}
              // on page load jsonEditorValue key will be undefined, when onchange of editor is called from then onwards jsonEditorValue key will have value, its done like this since json editor needs exact data given by its onchange event (content) in state else undo redo wont work
              content={jsonEditorValue}
              onChange={(content) => {
                handleSingleConfigDetailsChange(config, content)
              }}
              headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
              onRenderContextMenu={(items, context) => {
                return this.handleContextMenuOptions({ items, context, config, selectedMeta, readOnly })
              }}
              onChangeMode={(mode) => this.handleJsonEditorModes(mode, config.id)}
              readOnly={readOnly}
              mode={mode}
            />
          )
        }
        const isJsonEditorModalOpen = this.state.jsonEditorsOpen?.[config.id] || false
        return <div className='summary-container' key={index}>
          {/*
            <TextAreaAppInput
              key={index}
              title={config.name}
              placeholder={`Enter ${config.name}`}
              inputName='title'
              isEditable={!isUpdateDisabled}
              value={selectedMeta ? selectedMeta.value : ''}
              handleChange={({ target }) => handleSingleConfigDetailsChange(config, target.value)}
              isRequired={config.isRequired}
              isError={selectedMeta ? selectedMeta.isEr``ror : false}
              jsonInvalidEntries={jsonInvalidEntries}
              currentId={config.id}
              tooltipText={config.tooltipText || null}
            />
          */}
          <div className='json-outside-modal-view-wrapper'>
            <p>{config.name}</p>
            <div
              className='json-editor-container'
              onClick={() => {
                // on clicking cancel on modal, editor should reset back, so saving initial state in local variable
                if (this.isInitialJsonEditorChange) {
                  this.isInitialJsonEditorValue = selectedMeta?.value
                  this.isInitialJsonEditorChange = false
                }
                this.handleJsonEditorOpenClose(true, config.id)
                // if content is empty set text view by default
                this.setDefaultMode(jsonEditorValue, config, DEFAULT_MODE)
                this.isFormDirty = this.props.isConfigSingleInstanceEdited
              }}
            >
              {/* mode will always tree mode in default view */}
              {getJsonEditorComponent(true, DEFAULT_MODE)}
            </div>
            <Modal
              title={`Edit - ${config.name}`}
              visible={isJsonEditorModalOpen}
              onOk={() => {
                this.isInitialJsonEditorChange = true
                this.isInitialJsonEditorValue = null
                this.handleJsonEditorOpenClose(false, config.id)
                this.setDefaultMode(jsonEditorValue, config, DEFAULT_MODE)
              }}
              onCancel={() => {
                // when canceled editor should reset back to previous state
                if (!isEqual(selectedMeta?.value, this.isInitialJsonEditorValue)) {
                  let saveButtonFlag = true
                  // false = button enable ( has change ), true = button disable ( no change )
                  if (this.isFormDirty) {
                    saveButtonFlag = true
                  } else {
                    saveButtonFlag = false
                  }
                  handleSingleConfigDetailsChange(config, { text: this.isInitialJsonEditorValue }, saveButtonFlag)
                }
                this.handleJsonEditorOpenClose(false, config.id)
                this.setDefaultMode(jsonEditorValue, config, DEFAULT_MODE)
                this.isFormDirty = null
              }}
              className='general-modal json-editor-modal'
              width={'calc(100vw - 100px)'}
              destroyOnClose
              style={{
                top: '10px',
                bottom: '10px',
                left: '10px',
                right: '10px'
              }}
            >
              <div className='json-editor-modal-container'>
                <div className='json-field-header'>
                  <div className='text-wrapper'>
                    <p>{config.name} {config?.isRequired && <span className='mandatory'>*</span>}</p>
                  </div>
                  <div className='icon-wrapper'>
                    <PopoverConfirm
                      warningMessage='Are you sure you want to clear the field ?'
                      confirm={() => handleSingleConfigDetailsChange(config, '')}
                    />
                    <Icon type='copy' onClick={() => this.copyOnClick(jsonEditorValue, 'JSON')} />
                  </div>
                </div>
                {getJsonEditorComponent(false, mode)}
              </div>
            </Modal>
          </div>

        </div>
      } else if (config.type === 'JSONARRAY') {
        return (
          <div className={'json-array-summary-container json-array-editor-container'} key={index}>
            <div className='json-summary-header'>
              <div><label>{config.name}</label>
                {config.isRequired
                  ? <span className='mandatory'>*</span> : ''}
                {config.tooltipText ? <span id='info-icon'>
                  <Tooltip
                    placement='rightTop'
                    childComponent={<div className='info-icon'><InformationIcon /></div>}
                    description={config.tooltipText}
                    parentCompoent='info-icon' />
                </span> : null
                }
              </div>
              {/* {isUpdateDisabled ? null : <EditButton onClick={() => handleJsonArrayVisibilty(config, selectedMeta)} />} */}
            </div>

            {/* <Table className={`json-array-table`} rowKey={record => record.id} columns={columns} dataSource={selectedJsonArrayTableValue} pagination={false} scroll={{ x: 1600, y: 240 }} /> */}
            <div
              className='json-editor-array-container'
              onClick={() => {
                if (!isUpdateDisabled) {
                  handleJsonArrayVisibilty(config, selectedMeta)
                  // if content is empty set text view by default
                  const value = selectedMeta ? selectedMeta.value : ''
                  const jsonEditorValue = selectedMeta?.jsonEditorValue
                  this.setDefaultMode(getJsonEditorArrayValue(jsonEditorValue, value), config, DEFAULT_MODE_JSON_ARRAY)
                }
              }}
            >
              <JsonEditor
                content={getJsonEditorContent(selectedMeta?.value)}
                // onChange={(content) => {
                //   handleSingleConfigDetailsChange(config, content, false)
                // }}
                // headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
                // onRenderContextMenu={(items, context) => {
                //   return this.handleContextMenuOptions(items, context)
                // }}
                readOnly
                mode={DEFAULT_MODE_JSON_ARRAY}
              />
            </div>
          </div>
        )
      } else if (config.type === 'IMAGE') {
        let selectedImage = selectedMeta && selectedMeta.value
        return <React.Fragment key={index}>
          {!selectedImage
            ? <div className={`image-container ${selectedMeta && selectedMeta.isError ? 'error' : ''}`}>
              <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}{config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
              <div className='image-container-thumb' style={{ backgroundImage: `url(${image})` }} onMouseEnter={() => this.showImgAddIcon(config)}
                onMouseLeave={this.hideImgAddIcon} >
                { (showAddIcon && !isUpdateDisabled && selectedImgConfigIcon.name === config.name) ? <div onClick={() => handleShowAddImageModal(config)} className='img-add-icon'> <AddIcon /> </div> : null }
              </div>
            </div>
            : <div className='image-details'> <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}{config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
              {this.showImageDetails(config, selectedMeta.value, index)}
            </div>}
          <AddImageModal
            isMultiSelect={false}
            isVisible={showAddImageModal && !isUpdateDisabled}
            handleSubmit={(selectedImage) => saveCurrentImageSelection(selectedImgConfig, selectedImage, 'CONFIG')}
            handleCancel={hideAddImageModal}
            mediaType='IMAGE'
            isUpdateDisabled={isUpdateDisabled}
            isSubmitButtonDisabled={isUpdateDisabled}
            project={project}
          />
          <EditImageModal
            type={'IMAGE'}
            isVisible={showImgEditModal && !isUpdateDisabled}
            hideImageEditor={hideImgEditor}
            imageId={editImageDetails && editImageDetails.id}
            mediaDetails={editImageDetails && editImageDetails}
            // query={queryParams}
            isUpdateBlocked={isUpdateDisabled}
            isUploadBlocked={isUpdateDisabled}
            project={project}
          />
        </React.Fragment>
      } else if (config.type === 'BUCKET') {
        let selectedBucketValue = selectedMeta && selectedMeta.value
        return <React.Fragment key={index}>
          {!selectedBucketValue ? <div className={`bucket-container  ${selectedMeta && selectedMeta.isError ? 'error' : ''}`} >
            <div><span>{config.name}</span>{config.isRequired ? <span className='mandatory'>*</span> : ''}{config && config.tooltipText ? <span id='info-icon'><Tooltip placement='right' childComponent={<div className='info-icon'><InformationIcon /></div>} description={config.tooltipText} parentCompoent='info-icon' /></span> : null }</div>
            <div className='bucket-container-thumb' style={{ backgroundImage: `url(${image})` }} onMouseEnter={() => this.showBucketAddIcon(config)}
              onMouseLeave={this.hideBucketAddIcon} >
              { (showBucketAddIcon && !isUpdateDisabled && selectedBucketconfigIcon.name === config.name) ? <div onClick={() => handleShowBucketModal(config)} className='bucket-add-icon'> <AddIcon /> </div> : null }
            </div>
          </div>
            : <div className='bucket-details-config'>
              <div className='info-header'>
                <span>{config.name}</span>
                {config.isRequired ? <span className='mandatory'>*</span> : ''}
                {config && config.tooltipText
                  ? <div id='info-icon'>
                    <Tooltip
                      placement='right'
                      childComponent={<div className='info-icon'><InformationIcon /></div>}
                      description={config.tooltipText}
                      parentCompoent='info-icon'
                    />
                  </div> : null }
              </div>
              {this.showBucketDetails(config, selectedMeta.value, index)}
            </div>}
          <AddBucketConfigAppModal
            isVisible={showAddBucketModal}
            handleCancel={hideAddBucketModal}
            handleBucketSelection={handleBucketSelection}
            selectedBucket={selectedBucket}
            handleSave={() => saveCurrentBucketSelection(selectedBucketConfig, 'CONFIG')}
            project={project}
          />
        </React.Fragment>
      } else if (config.type === DATE_TIME_TYPE.value) {
        const dateValue = selectedMeta?.value
          ? moment(new Date(selectedMeta.value))
          : null
        return (
          <div className='bucket-details-config'>
            <Row gutter={[12, 12]} align='middle' justify='center' type='flex'>
              <Col span={12} className='bucket-details-heading-container'>
                <p className='bucket-details-heading'>{config.name}</p>
                {config?.isRequired && <span className='mandatory'>*</span> }
                {config?.tooltipText && (
                  <span id='info-icon'>
                    <Tooltip
                      placement='right'
                      childComponent={
                        <div className='info-icon'>
                          <InformationIcon />
                        </div>
                      }
                      description={config.tooltipText}
                      parentCompoent='info-icon'
                    />
                  </span>
                )}
              </Col>
              <Col span={12}>
                <DateTimePicker
                  use12Hours={false}
                  date={dateValue}
                  dateFormat='DD MMM YYYY, hh:mm A'
                  onChange={(value) => handleSingleConfigDetailsChange(config, value)}
                  placeholder='Select Date time'
                  // disabledTime={endDate ? () => this.disabledRangeTime('end') : () => this.disableTimeComplete()}
                  // disabledDate={this.disableEndDate}
                  // onOpenChange={(value) => this.onOpenChange(value, false)}
                  status={selectedMeta?.isError ? 'error' : ''}
                />
              </Col>
            </Row>
          </div>
        )
      } else if (config.type === FILE_TYPE.value) {
        const supportedFileTypes = config?.supportedFileTypes || []
        let selectedFile = selectedMeta?.file?.fileName
        const isModalOpen = isCustomMetaRichTextModalOpen[config.id] === true
        return (
          <React.Fragment key={index}>
            <div className='image-container file-item-container'>
              <div>
                <span>{config.name}</span>
                {config.isRequired ? <span className='mandatory'>*</span> : ''}
                {
                  config?.tooltipText && (
                    <AntToolTip placement='right' title={config.tooltipText}>
                      <span className='asset-info-icon-boolean'>
                        <InformationIcon />
                      </span>
                    </AntToolTip>
                  )
                }
              </div>
              {
                !isEmpty(selectedFile)
                  ? (
                    <CustomMetaFileTypeIcon
                      fileName={selectedFile}
                      onClear={() => handleSingleConfigDetailsChange(config, '')}
                    />
                  )
                  : (
                    <>
                      <CustomMetaFileUploadIcon
                        onClick={() => {
                          this.setState({
                            isCustomMetaRichTextModalOpen: {
                              ...this.state.isCustomMetaRichTextModalOpen,
                              [config.id]: true
                            }
                          })
                        }}
                        toolTipTitle={supportedFileTypes?.join(', ')}
                      />
                      <CustomMetaFileModal
                        title='Select File'
                        project={this.props.project}
                        visible={isModalOpen}
                        onOk={(selectedItem) => {
                          console.log('selectedItem', selectedItem)
                          const fileName = selectedItem?.fileName
                          if (!fileName) {
                            message.error('Please select a valid file')
                          } else {
                            handleSingleConfigDetailsChange(config, { id: selectedItem?.id, fileName })
                          }
                          this.setState({ isCustomMetaRichTextModalOpen: {} })
                        }}
                        onCancel={() => {
                          this.setState({
                            isCustomMetaRichTextModalOpen: {}
                          })
                        }}
                        rootFolderItemsToShow={supportedFileTypes}
                      />
                    </>
                  )
              }
            </div>
          </React.Fragment>
        )
      }
    })
  }

  copyOnClick = (data, type) => {
    const value = data?.text || ''
    navigator.clipboard.writeText(value, type)
    message.success(`${type} Copied Successfully`)
  }

  handlBucketDetails = () => {
    this.setState({
      showBucketDetails: true
    })
  }

  hideBucketDetails = () => {
    this.setState({
      showBucketDetails: false
    })
  }

  render () {
    const { singleConfigDetails, details, jsonArrayInvalidEntries, handleSingleConfigDetailsChange, isJsonArrayValid, handleJsonArrayHide,
      isJsonArrayVisible, jsonConfig, jsonSelectedMeta, project } = this.props
    const { isJsonEditorImageModalOpen, jsonEditorModes } = this.state
    const currentId = jsonConfig?.id
    const currentJsonArrayMode = jsonEditorModes?.[currentId] || DEFAULT_MODE_JSON_ARRAY
    return (
      <div id='single-app-config-modal' className={`single-app-config-modal`}>
        {this.getObjectMetaFields(singleConfigDetails, _.sortBy(details.fields, 'position'))}
        {isJsonArrayVisible ? <JsonArrayViewModal
          key={jsonConfig.name}
          title={jsonConfig.name}
          placeholder={`Enter ${jsonConfig.name}`}
          inputName='title'
          value={jsonSelectedMeta ? jsonSelectedMeta.value : ''}
          jsonEditorValue={jsonSelectedMeta?.jsonEditorValue}
          isRequired={jsonConfig.isRequired}
          isError={jsonSelectedMeta ? jsonSelectedMeta.isError : false}
          handleChange={(value) => handleSingleConfigDetailsChange(jsonConfig, value)}
          isJsonArrayValid={isJsonArrayValid}
          jsonArrayInvalidEntries={jsonArrayInvalidEntries}
          currentId={currentId}
          isVisible={isJsonArrayVisible}
          handleCancel={handleJsonArrayHide}
          jsonConfig={jsonConfig}
          handleJsonArrayChange={this.handleJsonArrayChange}
          project={project}
          mode={currentJsonArrayMode}
          handleJsonEditorModes={this.handleJsonEditorModes}
        /> : null}
        <AddImageModal
          // onChangeModal={(a, b, c, d, f) => console.log('onChangeModal', { a, b, c, d, f })}
          // type={(a, b, c, d, f) => console.log('type', { a, b, c, d, f })}
          isMultiSelect={false}
          isVisible={isJsonEditorImageModalOpen}
          handleCancel={() => this.handleOpenImageModal(false)}
          isUpdateDisabled={false}
          handleSubmit={(selectedImage) => {
            const { jsonEditorImagePathDetails } = this.state
            // console.log('jsonEditorImagePathDetails', jsonEditorImagePathDetails)
            // integrate selected image to state
            const imagePathDetails = jsonEditorImagePathDetails?.selection
            const value = jsonEditorImagePathDetails?.selectedMeta?.value
            const config = jsonEditorImagePathDetails?.config
            const fileName = selectedImage?.[0]?.fileName || ''
            const contentCopy = value ? cloneDeep(JSON.parse(value)) : null
            const valuePath = imagePathDetails.path.join('.')
            set(contentCopy, valuePath, fileName)
            if (!isEmpty(contentCopy)) {
              const content = { text: JSON.stringify(contentCopy, null, JSON_EDITOR_INDENTATION) }
              handleSingleConfigDetailsChange(config, content)
              this.handleOpenImageModal(false)
            }
          }}
          isSubmitButtonDisabled={false}
          isCancelButtonDisabled={false}
          currentSelection={[]}
          mediaType='IMAGE'
          project={project}
        />
      </div>
    )
  }
}

SingleAppConfigs.propTypes = {

}

SingleAppConfigs.defaultProps = {
}

export default SingleAppConfigs
